import React, { useState } from 'react';
import { Box, Paper } from '@mui/material';
import { DropdownMenuProps } from 'components/dropdownMenu/dropDownMenu';
import DropdownMenuHeaderDesktop from 'components/dropdownMenu/components/dropdownMenuHeader/dropdownMenuHeaderDesktop';
import DropdownMenuInnerDesktop from 'components/dropdownMenu/components/dropdownMenuInner/dropdownMenuInnerDesktop';
import { borderRadiusValues } from 'assets/theme';
import { useAnchorParams } from 'hooks/useAnchorParams';

export default function DropdownMenuDesktop({
  initialIsOpen,
  data,
}: DropdownMenuProps) {
  const [isOpen, setIsOpen] = useState(initialIsOpen);
  const { offsetEl } = useAnchorParams();

  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '6px',
        width: offsetEl ? offsetEl.width : '100%',
        position: 'absolute',
        top: offsetEl ? `${offsetEl.top + offsetEl.height}px` : '0',
        left: offsetEl ? offsetEl.left : '0',
        borderRadius: offsetEl ? offsetEl.borderRadius : borderRadiusValues.big,
        zIndex: 2147483647,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: 0.96,
        }}
      >
        <DropdownMenuHeaderDesktop
          {...data}
          isOpen={isOpen}
          onChangeIsOpen={setIsOpen}
        ></DropdownMenuHeaderDesktop>

        <DropdownMenuInnerDesktop
          {...data}
          isOpen={isOpen}
        ></DropdownMenuInnerDesktop>
      </Box>
    </Paper>
  );
}
